import { Box, Button, Text } from "@chakra-ui/react";
import { ApiErrorProvider } from "@raiden/library/components/ReactHookForm/ApiError";
import useAuthAs from "@raiden/library/hooks/auth/as";
import { useApi } from "@raiden/library/hooks/useApi";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";
import { FormattedMessage, useIntl } from "react-intl";
import SWRHandler from "../../../components/SWR/SWRHandler";
import CustomersCafForm from "../../Users/Update/Caf/Form";
import CustomerCafUpdateHandler from "../../Users/Update/Caf/Handler";
import StepBottomBar from "../StepBottomBar";
import StepLayout from "../StepLayout";

/**
 * @typedef {Object} Props
 * @property {() => void} nextStep
 *
 * @param {Props} props
 */
function StepCaf({ nextStep }) {
  const intl = useIntl();

  const { user } = useAuthAs();

  /** @type {import("@raiden/library/hooks/useApi").UseApi<import("@raiden/library/types/Customer").Customer>} */
  const { swrResponse: swrResponseCustomer } = useApi(
    user
      ? generateApiUri({
          id: "@customers.view",
          parameters: {
            customerId: user.id,
          },
        })
      : null,
  );

  return (
    <StepLayout
      title={intl.formatMessage({ defaultMessage: "Situation familiale" })}>
      <Text colorScheme="gray" px="1rem" mt="1rem">
        <FormattedMessage defaultMessage="Ces informations seront utilisées afin de définir si vous pouvez bénéficier de nos tarifs réduits." />
      </Text>

      <SWRHandler
        swrResponse={swrResponseCustomer}
        wrapper={(children) => <Box p="1rem">{children}</Box>}>
        {(customerResponse) => (
          <ApiErrorProvider>
            <CustomerCafUpdateHandler
              customer={customerResponse.data}
              onSuccess={() => {
                nextStep();
              }}
              render={({ isLoading }) => (
                <>
                  <Box p="1rem">
                    <CustomersCafForm customer={customerResponse.data} />
                  </Box>

                  <StepBottomBar>
                    <Button
                      type="submit"
                      isLoading={isLoading}
                      colorScheme="brandSecondary">
                      <FormattedMessage defaultMessage="Enregistrer" />
                    </Button>
                  </StepBottomBar>
                </>
              )}
            />
          </ApiErrorProvider>
        )}
      </SWRHandler>
    </StepLayout>
  );
}

export default StepCaf;
